export const PUSH_TO_SNACKBAR = 'PUSH_TO_SNACKBAR';

export const POP_SNACKBAR = 'POP_SNACKBAR';

export const SET_LAYOUT = 'SET_LAYOUT';




// WEBPACK FOOTER //
// ./src/store/modules/app/mutationsTypes.js